import React from "react";

const Svg = ({width = 27}: {width?: number} = {}) => {
  return (
    <svg
      width="27"
      height={(width / 27) * 25}
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 0C6.0453 0 0 4.63331 0 10.344C0 13.8959 2.33955 17.0323 5.89545 18.8968L4.3956 24.3279C4.2606 24.802 4.8141 25.1856 5.2353 24.9045L11.8044 20.6135C12.3606 20.6734 12.9155 20.7027 13.5 20.7027C20.9547 20.7027 27 16.0708 27 10.3587C27 4.63198 20.9547 0 13.5 0Z"
        fill="black"
      />
    </svg>
  );
};
export default Svg;
